// 🔧 index.js
// ✅ Purpose: Seed Profile Registry
// ✅ Features:
// - Registers all Seed Engine profiles
// - Provides a single lookup point
// - Future-ready for unlimited profile types
// - Fully block-commented for clarity and future devs

import { CORE_DEMO_PROFILE } from "./core_demo_profile";

export const SEED_PROFILES = {
  core_demo: CORE_DEMO_PROFILE,
};

export const getSeedProfile = (
  profileKey = "core_demo"
) => {
  return (
    SEED_PROFILES[profileKey] ||
    CORE_DEMO_PROFILE
  );
};